/**
 * API de Infraestructura Hotelería
 * Gestión visual de zonas, módulos y habitaciones
 */

import pythonApiClient from './pythonBaseApi';

const API_BASE = '/procesos/hoteleria/infraestructura';

/**
 * Obtener resumen completo de infraestructura de un proyecto
 * @param {number} proyectoId - ID del proyecto
 * @returns {Promise} Estructura jerárquica de zonas, módulos y habitaciones
 */
export const getInfraestructuraResumen = async (proyectoId) => {
  const response = await pythonApiClient.get(`${API_BASE}/resumen`, {
    params: { proyecto_id: proyectoId }
  });
  return response.data;
};

/**
 * Obtener estadísticas globales de infraestructura
 * @param {number} proyectoId - ID del proyecto
 * @returns {Promise} Estadísticas totales
 */
export const getInfraestructuraEstadisticas = async (proyectoId) => {
  const response = await pythonApiClient.get(`${API_BASE}/estadisticas`, {
    params: { proyecto_id: proyectoId }
  });
  return response.data;
};

// ===================== ZONAS =====================

/**
 * Crear nueva zona
 * @param {Object} zonaData - Datos de la zona
 * @returns {Promise} Zona creada
 */
export const createZona = async (zonaData) => {
  const response = await pythonApiClient.post(`${API_BASE}/zonas`, zonaData);
  return response.data;
};

/**
 * Actualizar zona
 * @param {number} zonaId - ID de la zona
 * @param {Object} zonaData - Datos a actualizar
 * @returns {Promise} Zona actualizada
 */
export const updateZona = async (zonaId, zonaData) => {
  const response = await pythonApiClient.put(`${API_BASE}/zonas/${zonaId}`, zonaData);
  return response.data;
};

/**
 * Eliminar zona
 * @param {number} zonaId - ID de la zona
 * @returns {Promise} Confirmación de eliminación
 */
export const deleteZona = async (zonaId) => {
  const response = await pythonApiClient.delete(`${API_BASE}/zonas/${zonaId}`);
  return response.data;
};

// ===================== MÓDULOS =====================

/**
 * Crear nuevo módulo
 * @param {Object} moduloData - Datos del módulo
 * @returns {Promise} Módulo creado
 */
export const createModulo = async (moduloData) => {
  const response = await pythonApiClient.post(`${API_BASE}/modulos`, moduloData);
  return response.data;
};

/**
 * Actualizar módulo
 * @param {number} moduloId - ID del módulo
 * @param {Object} moduloData - Datos a actualizar
 * @returns {Promise} Módulo actualizado
 */
export const updateModulo = async (moduloId, moduloData) => {
  const response = await pythonApiClient.put(`${API_BASE}/modulos/${moduloId}`, moduloData);
  return response.data;
};

/**
 * Eliminar módulo
 * @param {number} moduloId - ID del módulo
 * @returns {Promise} Confirmación de eliminación
 */
export const deleteModulo = async (moduloId) => {
  const response = await pythonApiClient.delete(`${API_BASE}/modulos/${moduloId}`);
  return response.data;
};

// ===================== HABITACIONES =====================

/**
 * Crear nueva habitación
 * @param {Object} habitacionData - Datos de la habitación
 * @returns {Promise} Habitación creada
 */
export const createHabitacion = async (habitacionData) => {
  const response = await pythonApiClient.post(`${API_BASE}/habitaciones`, habitacionData);
  return response.data;
};

/**
 * Actualizar habitación
 * @param {number} habitacionId - ID de la habitación
 * @param {Object} habitacionData - Datos a actualizar
 * @returns {Promise} Habitación actualizada
 */
export const updateHabitacion = async (habitacionId, habitacionData) => {
  const response = await pythonApiClient.put(`${API_BASE}/habitaciones/${habitacionId}`, habitacionData);
  return response.data;
};

/**
 * Eliminar habitación
 * @param {number} habitacionId - ID de la habitación
 * @returns {Promise} Confirmación de eliminación
 */
export const deleteHabitacion = async (habitacionId) => {
  const response = await pythonApiClient.delete(`${API_BASE}/habitaciones/${habitacionId}`);
  return response.data;
};
